import React from 'react';
import { useTheme } from '../context/ThemeContext';

const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const { darkMode } = useTheme();
  const sizes = {
    small: { width: 50, fontSize: 'text-xs' },
    default: { width: 80, fontSize: 'text-lg' },
    large: { width: 120, fontSize: 'text-3xl' }
  };

  const { width, fontSize } = sizes[size] || sizes.default;

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* Logo Image */}
      <img
        src="/logo.png"
        alt="CampusConnect Logo"
        className="mb-2 object-contain transition-all duration-300 ease-in-out"
        style={{
          width: `${width + 16}px`,
          maxWidth: '100%',
          height: 'auto'
        }}
        onError={(e) => {
          // Fallback to text logo if image fails to load
          e.target.style.display = 'none';
          const fallback = e.target.nextElementSibling;
          if (fallback) fallback.style.display = 'flex';
        }}
      />
      {/* Fallback text logo (hidden by default) */}
      <div
        className="mb-2 rounded-lg p-2 flex items-center justify-center bg-indigo-600 text-white font-bold"
        style={{
          width: `${width + 16}px`,
          height: `${width + 16}px`,
          fontSize: `${width * 0.4}px`,
          display: 'none'
        }}
      >
        CC
      </div>

      {/* Text: CAMPUSCONNECT */}
      {showText && (
        <div 
          className={`font-bold uppercase tracking-tight ${fontSize} leading-tight text-indigo-400`} 
          style={{ 
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            letterSpacing: '-0.02em'
          }}
        >
          CAMPUSCONNECT
        </div>
      )}
    </div>
  );
};

// Export both default and named for compatibility with static and dynamic imports
// This ensures Logo works correctly when imported by lazy-loaded components
// CRITICAL: Both exports must be present for lazy-loaded components to work
export default Logo;
export { Logo };

// Ensure Logo is available globally for lazy-loaded components
// This provides a fallback if the module import fails
if (typeof window !== 'undefined') {
  window.__LogoFallback = Logo;
  window.__LogoComponent = Logo;
}
